import { ChainId } from '@pancakeswap/sdk'

export const INFO_CLIENT_BITGERT = 'https://subgraph.qomswap.com/subgraphs/name/test/exchange'
export const BLOCKS_CLIENT_BITGERT = 'https://subgraph.qomswap.com/subgraphs/name/test/blocks'

export const INFO_CLIENT_XDC = 'https://graph-xdc.icecreamswap.com/subgraphs/name/simone1999/icecreamswap-xdc'
export const BLOCKS_CLIENT_XDC = 'https://graph-xdc.icecreamswap.com/subgraphs/name/icecreamswap/blocks-xdc'

export const INFO_CLIENT_CORE = 'http://localhost:8000/subgraphs/name/test/qomswap-core'
export const BLOCKS_CLIENT_CORE = 'http://localhost:8000/subgraphs/name/test/blocks-qom'

export const STABLESWAP_SUBGRAPH_CLIENT = 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-stableswap'
export const GRAPH_HEALTH = 'https://api.thegraph.com/index-node/graphql'

export const FARM_API = 'https://farms.pancake-swap.workers.dev'

export const BIT_QUERY = 'https://graphql.bitquery.io'

export const ACCESS_RISK_API = 'https://red.alert.pancakeswap.com/red-api'

export const CELER_API = 'https://api.celerscan.com/scan'

export const INFO_CLIENT_WITH_CHAIN = {
  [ChainId.QOM]: INFO_CLIENT_BITGERT,
  // [ChainId.XDC]: INFO_CLIENT_XDC,
  [ChainId.TQOM]: INFO_CLIENT_CORE,
}

export const BLOCKS_CLIENT_WITH_CHAIN: Partial<Record<ChainId, string>> = {
  [ChainId.QOM]: BLOCKS_CLIENT_BITGERT,
  // [ChainId.XDC]: BLOCKS_CLIENT_XDC,
  [ChainId.TQOM]: BLOCKS_CLIENT_CORE,
}
